<template>
  <RouterView />
  <CustomNotification />
</template>

<script setup>
import CustomNotification from '@/components/CustomNotification.vue';
import { setLanguage } from '@/services/language.service';
import { useI18n } from 'vue-i18n';

const updateHtmlLang = (locale) => {
  document.documentElement.setAttribute('lang', locale);
}

const { locale } = useI18n();
updateHtmlLang(locale.value);

setLanguage('de');
</script>
